import React, { useEffect, useState } from 'react';
import css from './AddNewStudent.module.css';
import toShort from '../../../../../services/utils/dateParser';

import * as studentServices from '../../../../../services/studentServices';
import AddEditForm from '../../../_common/elements/forms/AddEditForm';
import FormButtons from '../../../_common/elements/forms/FormButtons';
import FormComment from '../../../_common/elements/forms/FormComent';
import FormData from '../../../_common/elements/forms/FormData';

function AddNewStudent({ data, onAdd, toggleModal, studentData, func = 'add' }) {
    const [message, setMessage] = useState({ message: '', color: 'black' }); //check why colors are not changing
    const [nextStudentNo, setNextStudentNo] = useState('');

    // console.log(studentData);

    let template = {
        studentNo: studentData?.studentNo || nextStudentNo,
        studentFirstName: studentData?.studentFirstName || '',
        // studentMidName: (studentData && studentData.studentMidName === 'null' ? '' : studentData.studentMidName) || '',
        studentMidName: studentData?.studentMidName || '',
        studentLastName: studentData?.studentLastName || '',
        studentDoB: (studentData && toShort(studentData.studentDoB, 1)) || '',
        studentPoB: studentData?.studentPoB || '',
        studentEmail: studentData?.studentEmail || '',
        studentPhone: studentData?.studentPhone || '',
        studentNotes: studentData?.studentNotes || '',
    };

    const [newData, setNewData] = useState(template);

    useEffect(() => {
        if (data) {
            const nextNo = () => {
                let current = data.sort((a, b) => b.ID.localeCompare(a.ID))[0].ID;
                let next = Number(current.slice(1)) + 1;
                next = 'S' + String(next).padStart(4, '0');
                setNextStudentNo((state) => next);
                setNewData((state) => ({ ...state, studentNo: nextStudentNo }));
            };
            nextNo();
        }
    }, [data, nextStudentNo]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setNewData((state) => ({
            ...state,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        studentServices
            .create(newData)
            .then((result) => {
                console.log(result);
                setNewData((prevDate) => template);
                setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
                onAdd(newData);
                return true;
            })
            .catch((err) => {
                // console.log(err);
                setMessage((state) => ({ message: 'Sorry, something went wrong!', color: 'red' })); //check why colors are not changing
                console.log(message); //check why colors are not changing
                return false;
            });
    };

    const onAddStay = (e) => {
        handleSubmit(e);
        setNewData((state) => template);
    };

    const onAddClose = (e) => {
        let pass = handleSubmit(e);
        if (pass) {
            toggleModal();
        }
    };

    const onEdit = (e) => {
        e.preventDefault();
        console.log(newData);
        const updateData = newData;
        updateData._id = studentData.studentId;
        console.log(updateData);

        studentServices
            .edit(updateData)
            .then((res) => {
                setMessage({
                    message: `${updateData.studentFirstName} ${updateData.studentLastName} is updated successfully!`,
                    color: 'green',
                });
                toggleModal();
            })
            .catch((err) => {
                setMessage({ message: err.message || 'Unknown error ...', color: 'red' });
            });
    };

    return (
        <AddEditForm>
            <FormData>
                <label className={css.label} htmlFor="studentNo">
                    Student ID:{' '}
                </label>
                <input className={css.input} type="text" id="studentNo" value={newData.studentNo} onChange={handleChange} disabled />

                <label className={css.label} htmlFor="studentFirstName">
                    First Name:{' '}
                </label>
                <input className={css.input} type="text" id="studentFirstName" value={newData.studentFirstName} onChange={handleChange} />

                <label className={css.label} htmlFor="studentMidName">
                    Mid Name (if any):{' '}
                </label>
                <input className={css.input} type="text" id="studentMidName" value={newData.studentMidName} onChange={handleChange} />

                <label className={css.label} htmlFor="studentLastName">
                    Last Name:{' '}
                </label>
                <input className={css.input} type="text" id="studentLastName" value={newData.studentLastName} onChange={handleChange} />

                <label className={css.label} htmlFor="studentDoB">
                    Date of birth:{' '}
                </label>
                <input className={css.input} type="date" id="studentDoB" value={newData.studentDoB} onChange={handleChange} />

                <label className={css.label} htmlFor="studentPoB">
                    Place of birth:{' '}
                </label>
                <input className={css.input} type="text" id="studentPoB" value={newData.studentPoB} onChange={handleChange} />

                <label className={css.label} htmlFor="studentEmail">
                    Email:{' '}
                </label>
                <input className={css.input} type="mail" id="studentEmail" value={newData.studentEmail} onChange={handleChange} />

                <label className={css.label} htmlFor="studentPhone">
                    Phone:{' '}
                </label>
                <input className={css.input} type="text" id="studentPhone" value={newData.studentPhone} onChange={handleChange} />
            </FormData>
            <FormComment>
                <label htmlFor="studentNotes">Notes</label>
                <textarea id="studentNotes" className={css.textarea} rows="32" onChange={handleChange}>
                    {newData.studentNotes}
                </textarea>
            </FormComment>
            <FormButtons>
                {func === 'add' && (
                    <div className={css.submitButtons}>
                        <button className={css.greenButton} onClick={onAddStay}>
                            Add Student and stay
                        </button>
                        <button className={css.greenButton} onClick={onAddClose}>
                            Add Student and close
                        </button>
                    </div>
                )}
                {func === 'edit' && (
                    <div className={css.submitButtons}>
                        <button className={css.orangeButton} onClick={onEdit}>
                            Edit Student
                        </button>
                    </div>
                )}
                <button onClick={toggleModal} className={`${css.redButton} ${css.buttonClose}`}>
                    Cancel
                </button>
            </FormButtons>
            <p className={css[message.color]}>{message.message}</p>
        </AddEditForm>
    );
}

export default AddNewStudent;
